import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { color } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import Dialog from '@mui/material/Dialog';

import CreateAccount from '../../../shared/CreateAccount/CreateAccount';
import SignIn from '../../../shared/SignIn/SignIn';

export default function GuestButton({
  guestUserResetPath,
  shouldConvertGuest,
}) {
  const { t } = useTranslation('header');
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openSignInModal, setOpenSignInModal] = useState(false);

  return (
    <Wrapper>
      {shouldConvertGuest === 'true' && (
        <Button
          variant="outlinedBlue"
          id="createAccountButton"
          href="#"
          color="primary.100"
          onClick={() => setOpenCreateModal(true)}
        >
          {t('guestButtons.createAccount')}
        </Button>
      )}
      <Button
        id="signInButton"
        color="black.80"
        onClick={() => setOpenSignInModal(true)}
      >
        {t('guestButtons.signIn')}
      </Button>
      <StartOverButton
        id="guestUserConversion"
        data-method="patch"
        href={guestUserResetPath}
      >
        {t('guestButtons.startOver')}
      </StartOverButton>

      <Dialog open={openCreateModal} onClose={() => setOpenCreateModal(false)}>
        {openCreateModal && (
          <CreateAccount
            origin="header"
            setOpenCreateModal={setOpenCreateModal}
          />
        )}
      </Dialog>

      <Dialog open={openSignInModal} onClose={() => setOpenSignInModal(false)}>
        <SignIn
          setOpenSignInModal={setOpenSignInModal}
          setOpenCreateModal={setOpenCreateModal}
        />
      </Dialog>
    </Wrapper>
  );
}

GuestButton.propTypes = {
  guestUserResetPath: PropTypes.string,
  shouldConvertGuest: PropTypes.string,
};

const Wrapper = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row-reverse;
  ${themeGet('mediaQueries.forMediumUp')} {
    flex-direction: row;
  }
`;

const Button = styled.button`
  border: 1px solid #007eff;
  box-sizing: border-box;
  border-radius: 8px;
  background: transparent;
  margin: 0;
  ${color};
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  border: none;

  &:hover {
    background: #007eff;
    color: white;
  }

  &:focus {
    background: transparent;
    color: #007eff;
  }

  ${themeGet('mediaQueries.forMediumUp')} {
    padding: 11px 16px;
    font-size: 14px;
    border: 1px solid ${themeGet('colors.primary.100')};
    color: ${themeGet('colors.primary.100')};
  }
  &:nth-child(2) {
    margin: 0 16px;
  }
`;

Button.defaultProps = {
  as: 'a',
};

const StartOverButton = styled(Button)`
  display: none;
  ${themeGet('mediaQueries.forMediumUp')} {
    display: inline;
  }
`;
